import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemFilter = function IconSystemFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 5h6m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0m8 0h4M3 12h6m8 0h4m-4 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0M3 19h4m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0m8 0h6"
  }));
};